<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        :title="`Dispensações (${paciente.nome})`"
        extraLarge
        ref="Modal"
    >
        <rkm-table
            :fields="fields"
            :items="dispensacoes"
            :tbody-tr-class="rowClass"
            class="table-dispensacoes"
            sort-by="dispensadoEm"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :disabled="!!item.estornado"
                    :title="!!item.estornado ? 'Estornado' : 'Estornar'"
                    @click="handleEstorno(item)"
                    color="danger"
                    small
                >
                    <rkm-icon icon="undo-alt" />
                </rkm-button>
            </template>

            <template #afterPagination>
                <div class="mt-2">
                    <rkm-row>
                        <rkm-col>
                            <p class="m-0">A linha em <span class="red">vermelho</span> representa que a dispensação foi estornada.</p>
                        </rkm-col>
                    </rkm-row>
                </div>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { repository, error, formats } from '@/mixins'

export default {
    created() {

        this.repositories = {
            estornoDispensacao: this.getConectaSusRepository('farmacia.estornoDispensacao'),
            balancete: this.getConectaSusRepository('almoxarifado.balancete'),
        }
    },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'dispensadoEm',
                    label: 'Data/hora da dispensação',
                    class: 'col-min text-center',
                    formatter: value => this.formatDateTime(value),
                    filterByFormatted: true,
                    sortable: true
                },
                { key: 'material', label: 'Medicamento', sortable: true },
                { key: 'medico', label: 'Médico solicitante', sortable: true },
                { key: 'usuarioDispensacao', label: 'Usuário que dispensou', sortable: true },
                { key: 'quantidade', label: 'Quantidade', class: 'col-min text-center', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' }
            ]
        }
    },
    data: () => ({
        paciente: {},
        dispensacoes: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(paciente) {

            this.paciente = paciente
            this.itens = []

            this.$refs.Modal.show()
            this.load()
        },
        load() {

            this.setLoading();

            this.repositories.estornoDispensacao.edit(this.paciente.id)
                .then(({ data }) => this.dispensacoes = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEstorno(item) {

            this.setLoading()

            this.repositories.balancete.checkDate(item.dataSaida)
                .then(({ data }) => {

                    if (!data.mesFechado) {

                        this.showDeleteConfirmation(
                            ' O valor será estornada para unidade que realizou a dispensação. Deseja realmente estornar a dispensação?',
                            () => this.repositories.estornoDispensacao.update(item.id)
                                .then(() => item.estornado = true),
                            this.handleError
                        )

                        return
                    }

                    this.showValidationNotification(
                        'A data da dispensação corresponde a um mês já finalizado. Estorno não permitido.'
                    )
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        rowClass(item, type) {

            if (type === 'row' && item && !!item.estornado) {

                return 'table-danger'
            }
        }
    },
    mixins: [repository, error, formats]
}
</script>

<style scoped>
.table-dispensacoes >>> .red { color: red; }
</style>